import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import debounce from "lodash/debounce";
import Auth from "./modules/Auth.js";
import axios from "axios";
import NavBar from "./components/NavBar.js";
import { ToastContext } from "./contexts/ToastContext";
import Honeybadger from 'honeybadger-js'
import formatErrorSummary from "./utils/ErrorSummary.js";
//import creditLine from "./img/credit-page-line-3.png";
//import creditLine2 from "./img/credit-page-line-3 2.png";
//import creditLine3 from "./img/credit-page-line-3 2.png";
//import download from "./img/credit-page-outlineclouddownloadblack48dp.png";

class Uploader extends Component {
  static contextType = ToastContext;
  constructor() {
    super();
    const hb_config = {
      api_key: process.env.REACT_APP_HB_KEY,
      environment: process.env.REACT_APP_CURRENT_ENV,
      revision: 'current'
    }
    this.honeybadger = Honeybadger.configure(hb_config)
    this.state = {
      honeybadger: this.honeybadger,
      creating: false,
      guid: '',
      redirectToReferrer: false,
      auth: Auth.isAuthenticated(),
      orderNameError: false
    };
   this.handleChange = this.handleChange.bind(this);
   this.checkUniqueOrderName = debounce(this.checkUniqueOrderName.bind(this),200);
   this.throwError = this.throwError.bind(this)
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.innerHtml = "";
    document.body.appendChild(script);
  }

  handleChange(e) {
    const name = e.target.name;
    const val = e.target.value;

    if (name === "orderName") {
      this.checkUniqueOrderName(val)
    }
      this.setState({
        [name]: val
      });
    
    //console.log(this.state);
  }

  checkUniqueOrderName(name) {
    var token = Auth.getToken()

    axios
    .post('/api/v2/check_unique_order_name',{order_name: name}, {headers: {'token': token}})
         .then((res) => {
           this.setState({
             orderNameError: true
           })
         })
         .catch((err) =>{
          this.setState({
            orderNameError: false,
            name: name
          })
         })
  }


  handleSubmit(e) {
    e.preventDefault()
    this.setState({
      creating: true
    });

    var token = Auth.getToken()
    axios
    .post('/api/v2/lab_orders',
          {order_name: this.state.orderName,
          }, {headers: {'token': token}})
          .then(res => {
            //console.log(result);
            var orderGuid = res.data.data.attributes.guid
            this.setState({
              guid: orderGuid
            });
          })
          .catch(err =>
                 this.throwError(err))
  }

  throwError(err) {
    let errorMessage, errorObject
    if(!err.response){
      errorMessage = "Something went wrong:Please check your internet connection and try again."
      this.context(errorMessage, { type: "error"});
      this.setState({
        loading: false,
        errorState: true,
        errorMessage: errorMessage
      })
      return;
    }
    if (err.response.data["error"] && err.response.data["error"].status === 401) {
      this.setState({
        userLoggedOut: true
      })
      return false
    } else {
      if (err.response.data["error"] != null) {
        errorObject = err.response.data["error"]
        errorMessage = "\nERROR CODE: " + errorObject.status + "\nERROR CLASS: " + errorObject.class_name + " \nERROR MESSAGE: " + errorObject.user_message["message"]
        if (errorObject["more_info"] != null) {
          this.state.honeybadger.notify(err)
          this.context(formatErrorSummary(errorMessage), { type: "error"});
          console.log("ERROR: " + errorMessage + "\nMORE INFO: " + errorObject["more_info"].join(" ,").split(",").join("\n"))
        } else {
          this.state.honeybadger.notify(err)
          this.context(formatErrorSummary(errorMessage), { type: "error"});
          console.log(errorMessage + " More info not available.")
        }
      } else { 
        errorMessage = "\nERROR CODE: " + err.response.status + "\n ERROR MESSAGE: " + err.response.message
      }
    }
    this.setState({
      loading: false,
      query: "",
      errorState: true,
      creating: false,
      errorMessage: errorMessage
    })
  }

  render() {

    let orderNameErrorField;
    if (this.state.orderNameError) {
      orderNameErrorField = <div style={{ width: '100%', textAlign: 'center' }}>
        <p className="w-form-fail" name="orderNameError" style={{display: 'inline-block', marginLeft:'auto', marginRight:'auto'}}>
        Order Name already taken. Please create a different Order Name.
        </p>
      </div>
    }  else {
      orderNameErrorField = <div></div>
    }

    if (this.state.guid && this.state.guid.length > 0 ) {
      const redirectPath = `/lab-orders/${this.state.guid}/upload-progress`;
      return <Redirect push to={{ pathname: redirectPath, state: { guid: this.state.guid } }} />
    }

    let createOrderButton
    if (this.state.orderName && this.state.orderName.length > 0 && !this.state.orderNameError) {
      createOrderButton = <input type="submit" style={{width: '200px'}} value="SAVE AND UPLOAD" onClick={(e) => {this.handleSubmit(e)}} className="submit-button-2 w-button"/>
    } else {
      createOrderButton = <div value="UPLOAD" style={{width: '200px', color: 'white', height: '40px', opacity: '0.5', pointer: 'default', pointerEvents: 'none', textAlign: 'center'}} className="submit-button-2 w-button">SAVE AND UPLOAD</div>
    }

  if (this.state.creating) {
      return (
        <div>
          <NavBar />
          <div className="Uploader">
            <div style={{marginTop: '10%', marginLeft: '45%',
            fontSize: '22px', fontWeight: 700}}>
              creating order...
            </div>
          </div>
        </div>
      );
    } else if (this.state.errorState) {
      return (
        <div>
          <NavBar />
          <div className="Uploader">
            <div style={{marginTop: '10%', marginLeft: '25%',
              width: '50%', textAlign: 'center',
            fontSize: '22px', fontWeight: 700}}>
              ERROR LOADING: {this.state.errorMessage}
              <br/>
            <Link to="/lab-orders/upload">
                reload this page
            </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <NavBar />
          <div className="w-form">
            <form id="email-form" name="email-form" data-name="Email Form" className="form-2" >
              <input type="text" className="text-field-3 w-input" onChange={this.handleChange} style={{marginBottom:'20px'}} name="orderName" placeholder="Order Name"/>
              {orderNameErrorField}
              {createOrderButton}
            </form>
          </div>


        </div>
      );
    }
  }
}

export default Uploader;
